
const ROUTES = [
  ['PUT', /^\/v2\/daily-situation\/config$/, 'daily-situation.config'],
  ['POST', /^\/v2\/daily-situation\/finalize$/, 'daily-situation.finalize'],
  ['PUT', /^\/extras\/(\d+)\/stock-tracking$/, 'extra.stock-tracking', ['extra_id']],
  ['POST', /^\/stock-movements$/, 'stock-movement.create'],
  ['POST', /^\/perishable-batches$/, 'perishable-batch.create'],
  ["POST", /^\/warehouses$/, "warehouse.create"],
  ["PUT", /^\/warehouses\/(\d+)$/, "warehouse.update", ["id"]],
  ["DELETE", /^\/warehouses\/(\d+)$/, "warehouse.delete", ["id"]],
  ["POST", /^\/suppliers$/, "supplier.create"],
  ["PUT", /^\/suppliers\/(\d+)$/, "supplier.update", ["id"]],
  ["DELETE", /^\/suppliers\/(\d+)$/, "supplier.delete", ["id"]],
  ["PUT", /^\/product-suppliers\/(\d+)$/, "product-suppliers.update", ["product_id"]],
  ["POST", /^\/stock-items$/, "stock-item.create"],
  ["PUT", /^\/stock-items\/(\d+)$/, "stock-item.update", ["id"]],
  ["DELETE", /^\/stock-items\/(\d+)$/, "stock-item.delete", ["id"]],
  ["PUT", /^\/stock-items\/(\d+)\/packaging$/, "stock-item.packaging", ["id"]],
  ["POST", /^\/stock-items\/(\d+)\/revalue$/, "stock-item.revalue", ["id"]],
  ["PUT", /^\/stock-items\/(\d+)\/warehouse$/, "stock-item.warehouse", ["id"]],
  ["POST", /^\/stock-items\/ensure-catalog-link$/, "stock-item.ensure-link"],
  ["POST", /^\/extras\/(\d+)\/ensure-resold-stock-item$/, "extra.ensure-resold-stock-item", ["extra_id"]],
  ["POST", /^\/purchase-orders$/, "purchase-order.create"],
  ["PUT", /^\/purchase-orders\/(\d+)$/, "purchase-order.update", ["id"]],
  ["DELETE", /^\/purchase-orders\/(\d+)$/, "purchase-order.delete", ["id"]],
  ["POST", /^\/purchase-orders\/(\d+)\/cancel$/, "purchase-order.cancel", ["id"]],
  ["PUT", /^\/purchase-orders\/(\d+)\/status$/, "purchase-order.status", ["id"]],
  ["POST", /^\/purchase-orders\/(\d+)\/store$/, "purchase-order.receive", ["id"]],
  ["POST", /^\/recipes$/, "recipe.create"],
  ["PUT", /^\/recipes\/(\d+)$/, "recipe.update", ["id"]],
  ["DELETE", /^\/recipes\/(\d+)$/, "recipe.delete", ["id"]],
  ["POST", /^\/inventories$/, "inventory.create"],
  ["POST", /^\/inventories\/(\d+)\/items$/, "inventory.count", ["inventory_id"]],
  ["DELETE", /^\/inventories\/(\d+)\/items\/(\d+)$/, "inventory.count-delete", ["inventory_id", "stock_item_id"]],
  ["POST", /^\/inventories\/(\d+)\/finalize$/, "inventory.finalize", ["id"]],
  ["POST", /^\/inventories\/(\d+)\/cancel$/, "inventory.cancel", ["id"]],
  ["POST", /^\/loss-reports$/, "loss.create"],
  ["POST", /^\/loss-reports\/(\d+)\/validate$/, "loss.validate", ["id"]],
  ["POST", /^\/loss-reports\/(\d+)\/refuse$/, "loss.refuse", ["id"]],
  ["POST", /^\/stock-settings$/, "stock-setting.create"],
  ["PUT", /^\/stock-settings\/(\d+)$/, "stock-setting.update", ["id"]],
  ["DELETE", /^\/stock-settings\/([^/]+)\/(\d+)$/, "stock-setting.delete", ["setting_type", "id"]],
];

const normalizePath = (value) => {
  const path = String(value || "").split("?")[0].replace(/^\/api\/(waise|keassa)/, "");
  return path.replace(/\/+$/, "") || "/";
};

const mapWaiseHttpMutationToCommand = ({ method, path, body = {}, expectedRevision = null }) => {
  const verb = String(method || "").toUpperCase();
  const routePath = normalizePath(path);
  if (verb === "POST" && routePath === "/stock-movements" && String(body?.movement_type || "").toLowerCase() === "loss") {
    return {
      commandType: "loss.create",
      payload: { ...body },
      expectedRevision,
    };
  }
  for (const [routeMethod, pattern, commandType, names = []] of ROUTES) {
    if (routeMethod !== verb) continue;
    const match = routePath.match(pattern);
    if (!match) continue;
    const routeParams = {};
    names.forEach((name, index) => {
      const raw = match[index + 1];
      routeParams[name] = /^\d+$/.test(raw) ? Number(raw) : raw;
    });
    return {
      commandType,
      payload: { ...body, ...routeParams },
      expectedRevision,
    };
  }
  return null;
};

module.exports = { mapWaiseHttpMutationToCommand, normalizePath };
